import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import es from '../public/locales/es/translation';
import es_AR from '../public/locales/es/ar/translation';
import es_BO from '../public/locales/es/bo/translation';
import es_CL from '../public/locales/es/cl/translation';
import es_CO from '../public/locales/es/co/translation';
import es_PE from '../public/locales/es/pe/translation';
import es_PY from '../public/locales/es/py/translation';
import es_UY from '../public/locales/es/py/translation';
import pt from '../public/locales/pt/translation';
import pt_BR from '../public/locales/pt/br/translation';

import {AgroHeaderTranslations} from 'agrofy-ui-components';

// import Backend from 'i18next-xhr-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
// translation catalog
const resources = {
  es: {
    translation: es
  },
  es_AR: {
    translation: es_AR
  },
  es_BO: {
    translation: es_BO
  },
  es_CL: {
    translation: es_CL
  },
  es_CO: {
    translation: es_CO
  },
  es_PE: {
    translation: es_PE
  },
  es_PY: {
    translation: es_PY
  },
  es_UY: {
    translation: es_UY
  },
  pt: {
    translation: pt
  },
  pt_BR: {
    translation: pt_BR
  }
};

const language = process.env.RAZZLE_LANGUAGE || window.env.RAZZLE_LANGUAGE;

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  // .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector) si se descomenta esta linea el idioma se detecta de manera automagica
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: language.slice(0,2),
    lng: language,
    debug: false,
    resources,
    react: {
      wait: true
    },
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
  });

export default i18n;
